import React from 'react';
import { FadeIn } from './FadeIn';
import { trackPixel } from '../lib/pixel';
import { ArrowRightIcon, ShieldCheckIcon, LockIcon } from 'lucide-react';
export function Offer() {
  return <section id="oferta" className="py-24 px-4 bg-brand-dark relative" data-id="element-53">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-volt/5 blur-[100px] rounded-full pointer-events-none" data-id="element-54" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-55">
        <FadeIn data-id="element-56">
          <div className="bg-brand-surface border-2 border-brand-volt p-8 sm:p-12 shadow-[0_0_50px_rgba(59,130,246,0.15)]" data-id="element-57">
            <div className="text-center mb-10" data-id="element-58">
              <span className="inline-block bg-brand-volt text-white font-bold px-4 py-1 text-sm tracking-widest mb-6" data-id="element-59">
                OFERTA POR TIEMPO LIMITADO
              </span>
              <h2 className="text-4xl sm:text-6xl font-black text-white mb-4" data-id="element-60">
                MEGA PACK TRAIL RUNNING
              </h2>
              <p className="text-xl text-gray-400 normal-case" data-id="element-61">
                Clases, planificaciones, ejercicios y recursos listos para
                profes de trail running.
              </p>
            </div>

            <div className="flex flex-col md:flex-row gap-12 items-center mb-12" data-id="element-62">
              <div className="flex-1 w-full" data-id="element-63">
                <ul className="space-y-4" data-id="element-64">
                  {['6 Tomos del Sistema Principal de Trail Running', 'Fundamentos, técnica, planificación y seguridad', 'Fuerza, estabilidad y prevención de lesiones', 'Entrenamientos específicos para subidas, bajadas y fondos', 'Gestión de grupos y venta de clases de trail', '5 Bonos prácticos listos para implementar', 'Acceso inmediato + pago único'].map((item, i) => <li key={i} className="flex items-center gap-3 text-white font-medium normal-case" data-id="element-65">
                      <div className="w-2 h-2 bg-brand-volt rounded-full shrink-0" data-id="element-66" />
                      <span data-id="element-67">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="flex-1 w-full text-center md:text-right border-t md:border-t-0 md:border-l border-brand-muted/20 pt-8 md:pt-0 md:pl-12" data-id="element-68">
                <div className="text-gray-500 line-through text-2xl mb-2 font-display" data-id="element-69">
                  $120.000 ARS
                </div>
                <div className="text-6xl sm:text-7xl font-black text-brand-volt mb-4" data-id="element-70">
                  $26.990
                </div>
                <p className="text-gray-400 text-sm normal-case mb-8" data-id="element-71">
                  Pago único. Acceso inmediato.
                </p>

                <a href="https://mega-pack-trail-running.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" onClick={() => trackPixel('InitiateCheckout', {
                content_name: 'Mega Pack Trail Running',
                value: 26990,
                currency: 'ARS'
              })} className="group w-full bg-brand-volt hover:bg-brand-voltHover text-white font-display px-8 py-5 flex items-center justify-center transition-all rounded-xl shadow-[6px_6px_0px_rgba(255,255,255,0.1)] hover:shadow-[8px_8px_0px_rgba(59,130,246,0.3)] hover:-translate-y-0.5" data-id="element-72">
                  <span className="flex items-center gap-3 font-black text-xl tracking-wide" data-id="element-73">
                    COMPRAR AHORA
                    <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" strokeWidth={3} data-id="element-74" />
                  </span>
                </a>
              </div>
            </div>

            {/* Trust Badges */}
            <div className="flex flex-wrap justify-center gap-6 pt-8 border-t border-brand-muted/20" data-id="element-75">
              <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-76">
                <ShieldCheckIcon className="w-5 h-5 text-brand-volt" data-id="element-77" />
                <span data-id="element-78">Garantía 7 días</span>
              </div>
              <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-79">
                <LockIcon className="w-5 h-5 text-brand-volt" data-id="element-80" />
                <span data-id="element-81">Pago Seguro</span>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Guarantee Section */}
        <FadeIn delay={0.2} className="mt-16 text-center max-w-2xl mx-auto" data-id="element-82">
          <ShieldCheckIcon className="w-16 h-16 text-brand-volt mx-auto mb-6" data-id="element-83" />
          <h3 className="text-3xl font-black text-white mb-4" data-id="element-84">RIESGO CERO.</h3>
          <p className="text-gray-400 text-lg normal-case leading-relaxed" data-id="element-85">
            Entrás al Mega Pack. Revisás los tomos, las clases y los bonos. Si
            en 7 días sentís que no te ayuda a preparar mejor tus clases de
            trail running, te devolvemos el 100% de tu dinero. Sin vueltas.
          </p>
        </FadeIn>
      </div>
    </section>;
}